/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2023-09-25 17:58:01
 * @FilePath: \baishu_react_ui\src\components\BsyDept\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React from 'react'
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import BsyDept from '../BsyDept';




export default class BsySelectDept extends BsyDept {


  static defaultProps = {
    baseCls: "bsy-select-dept",

    width: 350,
    height: 40,
    value: null,
    allowBlank: !0,
    noRepeat: !1,
    editable: !1,
    count: 100,
    limit: [],
    type: 'dept',
    dynamicType: "select",
    onStopEdit: null,
    onRelyLimit: null,

  }

  constructor(props) {
    super(props);
    this.element = React.createRef();
    window.deptSelectMap = window.deptSelectMap || {};
    if(props.source == "BsyFormWidgetManager")
      this.current_departments()
  }
 
  renderBody = () => {
    const { value, islinkQuery, ftoken, msg } = this.state;

    let item = window.deptSelectMap[value];
    if (BsyUtils.isObjectEmpty(item)) {
      item = { id: value }
    }
    return <>
      <ul className="select-list" >
        {
          value && item ? <li className="select-item" id={value}>
            <i className="select-icon icon-department"></i>
            <span>{BsyUtils._toDeptUser(item)}</span>
          </li> : <div className="select-empty"> </div>
        }
      </ul>
      {
        this.renderBtn('icon-widget-dept',item)
      }
 
    </>

  }

  render() {
    const { cssName, css } = this.options
    if (!this.isEnabled()) {
      return this.renderDisablePane()
    }
    return (
      <div className={cssName} style={css}
        ref={this.element}
        onClick={this.onClick}
      >
        {
          this.renderBody()
        }
      </div>
    )
  }
}
